<template>
    <div class="draws">
        <div class="draws__contents draws__contents__container">
        </div>
    </div>
</template>
<script>
import DrawsService from "@/services/draws.service";
import languageMixin from "@/mixins/language/language-mixin";
import { formatMoneyInt } from "@/components/common/utils";
export default {
    mixins: [languageMixin],
    components: {},
    data() {
        return {
            listWinners: [],
        };
    },
    mounted() {
        this.getListWinners();
    },
    methods: {
        getListWinners() {
            const parameters = this.$route.query.id
                ? this.$route.query.id
                : null;
            DrawsService.listWinners(parameters).then((res) => {
                if (res.status === 200) {
                    this.listWinners = res.data;
                }
            });
        },

        fomarNumberWinners(price) {
            let priceFormat = formatMoneyInt(parseFloat(price));
            return priceFormat;
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/draws.scss" />
